// src/components/NavBar.jsx
import React from 'react';
import { Navbar, Container, Nav, Dropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../styles/style.css';

const navItems = [
  { path: '/dashboard', icon: 'speedometer2', label: 'Dashboard' },
  { path: '/admin', icon: 'people', label: 'User Management' },
  { path: '/payrolls', icon: 'cash-coin', label: 'Payrolls' },
  { path: '/common-costs', icon: 'cash-coin', label: 'Common Costs' },
  { path: '/settings', icon: 'gear', label: 'Settings' },
];

function NavBar({ user, onLogout }) {
  return (
    <Navbar expand="lg" bg="dark" variant="dark" className="modern-navbar shadow-sm w-100">
      <Container fluid>
        <Navbar.Brand 
          as={NavLink} 
          to="/" 
          className="text-white ms-3 modern-brand"
        >
          <i className="bi bi-building me-1" /> FHS
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar" className="custom-toggler" />
        <Navbar.Collapse id="main-navbar">
          <Nav className="me-auto ms-3">
            {navItems.map(({ path, icon, label }) => (
              <Nav.Link
                as={NavLink}
                to={path}
                key={path}
                className="d-flex align-items-center me-3 nav-link-hover"
                end
              >
                <i className={`bi bi-${icon} me-1`} />
                {label}
              </Nav.Link>
            ))}
          </Nav>

          <Nav className="me-3">
            <Dropdown align="end">
              <Dropdown.Toggle 
                id="user-dropdown" 
                className="modern-dropdown-toggle d-flex align-items-center"
              >
                <i className="bi bi-person-circle me-2" />
                <span className="user-email">{user.email}</span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="modern-dropdown-menu">
                <Dropdown.Item 
                  as={NavLink} 
                  to="/profile" 
                  className="dropdown-item-hover d-flex align-items-center"
                >
                  <i className="bi bi-person me-2" /> Profile
                </Dropdown.Item>
                <Dropdown.Item 
                  as={NavLink} 
                  to="/settings" 
                  className="dropdown-item-hover d-flex align-items-center"
                >
                  <i className="bi bi-gear me-2" /> Settings
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item 
                  onClick={onLogout} 
                  className="dropdown-item-hover d-flex align-items-center"
                >
                  <i className="bi bi-box-arrow-right me-2" /> Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
